export default __webpack_public_path__ + "static/media/youtube.a4f02dec.svg";